import { render, staticRenderFns } from "./CoreBoxes.vue?vue&type=template&id=38fcb55d&scoped=true&"
import script from "./CoreBoxes.vue?vue&type=script&lang=js&"
export * from "./CoreBoxes.vue?vue&type=script&lang=js&"
import style0 from "./CoreBoxes.vue?vue&type=style&index=0&id=38fcb55d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fcb55d",
  null
  
)

export default component.exports